import { NakedButton } from '@qga/roo-ui/components';

import withProps from '../withProps';

export default withProps({
  color: 'ui.link',
  hoverColor: 'ui.linkHover',
})(NakedButton);
